var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',[_c('button',{staticClass:"btn btn-primary",domProps:{"innerHTML":_vm._s(_vm.displayValue)},on:{"click":_vm.showModal}}),_vm._v(" "),_c(_vm.attribute.modal,_vm._b({tag:"component",attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},'component',_vm.model,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }